import { ref } from 'vue'

export default () => {
  const isFullscreen = ref(false)

  const enterFullscreen = () => {
    isFullscreen.value = true
  }

  const exitFullscreen = () => {
    isFullscreen.value = false
  }

  return {
    isFullscreen,
    enterFullscreen,
    exitFullscreen,
  }
}
